export default "__VITE_ASSET__C8V$P0M1__"